import { Box } from '@mui/material';
import { handleScroll } from '@rumblefish/ui';
import { Layout } from '@rumblefish/ui/Rumblefish23Theme';
import React, { useRef } from 'react';
import { RecruitmentProcess } from '../careersPage/RecruitmentProcess';
import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { JobPostData } from './JobPost.data';
import type { JobPostProps } from './JobPost.types';
import {
  Hero,
  Requirements,
  Responsibilities,
  OurOffer,
  AboutTheProject,
  Contact,
} from './';

export const JobPost: React.FC<JobPostProps> = ({ blogPosts, jobPost }) => {
  const applyRef = useRef<HTMLDivElement>(null);

  const handleApplyClick = () => {
    handleScroll(applyRef);
  };

  const {
    metaData,
    heroProps,
    requirementsProps,
    responsibilitiesProps,
    ourOfferProps,
    aboutTheProjectProps,
    contactProps,
  } = new JobPostData(jobPost, handleApplyClick);

  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...metaData} />
      <Hero {...heroProps} />
      <Requirements {...requirementsProps} />
      <Responsibilities {...responsibilitiesProps} />
      <OurOffer {...ourOfferProps} />
      <AboutTheProject {...aboutTheProjectProps} />
      <RecruitmentProcess onSubmit={handleApplyClick} />
      <Box
        ref={applyRef}
        sx={{
          marginTop: '-36px',
          marginBottom: '36px',
        }}
      />
      <Contact {...contactProps} />
    </Layout>
  );
};
